<template>
	<v-container>
		<v-layout justify-center>
			<v-flex xs12 sm3 mt-3>
				<v-card>
					<v-card-title primary-title>
						<h1 class="headline mb-0 text-md-center">Sign in</h1>
					</v-card-title>
					<v-card-text>
						You have to login to use this Tool
					</v-card-text>
					<v-card-actions>
						<v-btn class="red darken-3 white--text" @click="login">Sign in with Google</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	name: 'TrakkenLogin',
	mounted() {
		this.$store.dispatch('getLoginState')
	},
	methods: {
		login() {
			this.$store.dispatch('login', { callbackURL: window.location.href })
		}
	}
}
</script>
<style></style>
